export default {
      id: "i-zero-tax-usage",
      viewBox: "0 0 49 37",
      url: __webpack_public_path__ + "img/sprite.svg#i-zero-tax",
      toString: function () {
        return this.url;
      }
    }